// AUTO-GENERATED by scripts/genWhoItsForTiling.mjs — DO NOT EDIT BY HAND.
// Which cover (0-based, into the section's artifact list) each card of the globe shows, arranged so
// no cover appears twice in one view. Valid only for the geometry recorded here; the component falls
// back to its own tiling when anything differs. Re-run the script after changing covers or cards.
export const WALL_TILING: {
  covers: number;
  cardW: number;
  cardH: number;
  cardGap: number;
  cards: number;
  tiling: readonly number[];
} = {
  covers: 48,
  cardW: 299,
  cardH: 168,
  cardGap: 55,
  cards: 129,
  tiling: [44, 18, 31, 28, 29, 0, 6, 7, 3, 29, 20, 11, 21, 17, 27, 22, 10, 16, 11, 7, 16, 2, 4, 25, 23, 37, 45, 1, 30, 34, 5, 14, 22, 26, 13, 24, 42, 5, 27, 19, 3, 10, 21, 44, 31, 27, 23, 45, 47, 28, 21, 41, 6, 16, 7, 0, 17, 13, 25, 20, 37, 35, 40, 43, 3, 10, 30, 34, 36, 14, 33, 11, 26, 46, 8, 42, 4, 12, 19, 1, 38, 18, 15, 39, 32, 29, 22, 9, 2, 24, 15, 6, 32, 33, 0, 17, 46, 20, 31, 35, 40, 43, 47, 28, 1, 30, 41, 8, 9, 8, 2, 4, 25, 23, 12, 18, 32, 26, 19, 38, 9, 5, 36, 12, 24, 13, 15, 39, 14],
};
